import Login from "@components/auth/Login";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/login")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Login />;
}
